import { Component, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { ValidatorType } from '@app/core/enums/validator-type.enum';
import { AbstractCellEditor, CustomCellEditorParams } from '@app/shared/components/cell-edit/abstract.cell-editor';

@Component({
  selector: 'select-cell-edit',
  templateUrl: './select-cell-edit.component.html',
  styleUrls: ['./select-cell-edit.component.scss'],
  standalone: false
})
export class SelectCellEditComponent extends AbstractCellEditor {
  public selectOptions: SelectCellEditOption[];
  //Display undefined option if the field is not required
  public optional: boolean;

  @ViewChild(MatSelect, {static: false}) public input: MatSelect;

  /**
   * Initialisation method for the render component
   * @param params A merge of default cell editor params and custom params
   */
  public agInit(params: CustomCellEditorParams): void {
    super.agInit(params);

    this.optional = this.params.required ? false : !this.params.fieldConfig?.field.validators.find(validator => {
      return validator.type == ValidatorType.REQUIRED;
    });
    this.selectOptions = this.params.selectOptions;
  }

  /**
   *  A hook to perform any necessary operation just after the GUI for this component has been rendered on the screen.
   *  This method is called each time the edit component is activated.
   */
  public afterGuiAttached(): void {
    this.input.focus();
    this.input.open();
  }

  /**
   * Gets called when focus should be put into the editor.
   */
  public focusIn(): void {
    this.input.focus();
  }

  /**
   * Return the final value - called by the grid once after editing is complete
   */
  public getValue(): string {
    return this.control.value ?? '';
  }
}

export interface SelectCellEditOption {
  label: string,
  optionValue: string
}
